import { render, staticRenderFns } from "./CropsType.vue?vue&type=template&id=151e20e8&"
import script from "./CropsType.vue?vue&type=script&lang=js&"
export * from "./CropsType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports